export const facebook_url = "https://www.facebook.com/AccountTDA"
export const instagram_url = "https://www.instagram.com/tda_luxury_toys/"
export const tokopedia_url = "https://www.tokopedia.com/tdaluxuryshop?source=universe&st=product"
export const youtube_url = "https://www.youtube.com/@tdaluxurytoys"